import type { StaticTextResource } from '../keys'

export const si: StaticTextResource = {
  'schedule.dueToday': 'අද {{time}} දක්වා',
  'schedule.dueTomorrow': 'හෙට {{time}} දක්වා',
  'schedule.durationRange':
    '{{start}} - {{end}} (දින {{currentDay}}/{{days}} දින)',
  'editReport.defaultPageName': 'පිටුව {{n}}',
  'editReport.defaultSectionName': 'කොටස',
  'editReport.defaultRepeatSectionName': 'පුනරාවර්තන කොටස',
}
